import './App.css';
import './assets/css/home.css'
import React, { Fragment, useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomePage from './components/views/HomePage.jsx';
import ProjectsPage from './components/views/ProjectsPage.jsx';
import "react-chatbot-kit/build/main.css";



function App() {
  window.addEventListener("scroll", function () {
    var scrolledPixels = window.scrollY;
    console.log("Scrolled pixels: " + scrolledPixels);
  });
  return (
    <Router>
      <Fragment>
        <Routes>
          <Route element={<HomePage />} path="/" />
          <Route element={<ProjectsPage />} path="/projects/" />
        </Routes>
      </Fragment>
    </Router>
  );
}

export default App;
